import { badgeTemplateClassifierEntityName, } from '../../../../backend/config/classifiers/badge-template-classifier/types';
import { useStorageGet } from '@juvare/platform-sdk-react/ui/hooks';
/**
 * Wrapper around useStorageGet to be used more like Server State Manager
 */
export function useStorageGetBadgeTemplate(id) {
    const res = useStorageGet(badgeTemplateClassifierEntityName, id, undefined, undefined, {
        dedupingInterval: 10000, // avoid re-fetching for period
    });
    return !res.data || res.data.data.status === 'active'
        ? res
        : Object.assign(Object.assign({}, res), { data: undefined });
}
